import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import debug from '../../services/debug';
import App from '../app/container';

interface ContactRouterProps {
  handleSetContactIDRoute: (contactId: string | undefined) => void;
}

function ContactRouter({ handleSetContactIDRoute }: ContactRouterProps) {
  const { ContactID } = useParams();

  debug('ContactRouter ContactID', ContactID);

  useEffect(() => {
    handleSetContactIDRoute(ContactID);
  }, []);

  return <App />;
}

export default ContactRouter;
